import { useState } from "react";
import { useNavigate } from "react-router";
// import { faqslist, deletefaqs } from '../../service/Mainservice';
// import { Alert, Snackbar } from "@mui/material";
import "../../assets/Styles/FAQS.css";
import Loader from "../../Loader/Loader";
import { Pencil, Plus, X } from "lucide-react";
import DeletePopup from "../../components/common/Aresure";
// import { deletefaqs, faqslist } from "../../service/Mainservice";

const FAQSList = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState([
    {
      question: "What is a name analysis?",
      answer:
        "A name analysis is a personalized evaluation of a name based on its sound, structure, and potential impact in personal, business, or corporate contexts.",
    },
    {
      question: "How long does the analysis take?",
      answer:
        "Once payment is confirmed, your analysis is typically completed within 1-3 business days.",
    },
    {
      question: "What types of name analysis are offered?",
      answer:
        "We offer three types: Personal Name Analysis, Business Name Analysis, and Corporate Brand Name Analysis.",
    },
    {
      question: "Can I request multiple analyses at once?",
      answer:
        "Yes, you can submit multiple requests. Each one will be processed and billed separately.",
    },
    {
      question: "How will I receive my analysis?",
      answer:
        "After completion, the analysis will be sent to your registered email. Make sure your email is accurate before submitting.",
    },
    {
      question: "What if I need changes or have questions?",
      answer:
        "You can reply to the analysis email or contact our support team within 7 days of receiving your report.",
    },
  ]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });
  const [searchvalue, setsearchvalue] = useState("");

  const navigate = useNavigate();

  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = async () => {
  //   try {
  //     const response = await faqslist();
  //     console.log(response);
  //     setData(response.data.data);
  //     // setpagination(response.data.pagination);
  //     setloading(false);
  //   } catch (error) {
  //     setloading(false);
  //     if (error.code === 401) {
  //       localStorage.clear();
  //       navigate("/");
  //     }
  //   }
  // };

  // const handlePageChange = (pageNumber) => {
  //   getData(pageNumber);
  // };

  // const handledelete = async () => {
  //   try {
  //     const response = await deletefaqs(id);
  //     getData();
  //     setshowdelete(false);
  //   } catch (error) {
  //     seterror(error.message);
  //     setOpen(true);
  //     if (error.code === 401) {
  //       localStorage.clear();
  //       navigate("/");
  //     }
  //     setshowdelete(false);
  //   }
  // };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">FAQS</h1>
          <h1 className="data_add" onClick={() => navigate("/Add_FAQS")}>
            <Plus /> Add FAQS
          </h1>
        </div>
        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.question}</td>
                        <td>{item.answer}</td>
                        <td>
                          {/* <button
                      // onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button> */}
                          <div className="user_actionicon">
                            <Pencil
                              sx={{ color: "var(--red)", cursor: "pointer" }}
                              onClick={() =>
                                navigate("/Edit_FAQS", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <X
                              sx={{ color: "var(--red)" }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {/* <Pagination pagedata={pagination} onPageChange={getData} /> */}
          </>
        ) : (
          <p className="nodata">No FAQS Added Yet</p>
        )}

        <DeletePopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handledelete={() => console.log("")}
          // handledelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      {/* <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar> */}
    </>
  );
};
export default FAQSList;
